export const products = [
  {
    id: 'vehicle-inspection',
    name: 'Light Vehicle Inspection',
    tagline: 'Pre-op inspections that reach maintenance automatically.',
    description:
      'Field crews complete pre-op inspections from any device. Defects communicate automatically to your maintenance manager, so nothing sits on a clipboard waiting to be noticed.',
    features: [
      'Mobile pre-op inspection forms',
      'Automatic maintenance manager notification',
      'Defect history by vehicle',
      'Operator accountability records',
    ],
  },
  {
    id: 'visitor-approval',
    name: 'Site Visitor Approval',
    tagline: 'Training acknowledgment and approval before boots hit the ground.',
    description:
      'Capture site visitor training acknowledgment and route approvals before arrival. Every visitor is documented, current, and cleared.',
    features: [
      'Visitor training acknowledgment',
      'Approval routing workflow',
      'Pre-arrival clearance records',
      'Auditable visitor history',
    ],
  },
  {
    id: 'certification-management',
    name: 'Mine Certification Management',
    tagline: 'MSHA 5000-23 documentation without the filing cabinet.',
    description:
      'Track and produce MSHA 5000-23 training documentation on demand. Certifications stay current and retrievable when an inspector asks.',
    features: [
      'MSHA 5000-23 documentation',
      'Certification currency tracking',
      'Inspector-ready records',
      'Expiration visibility',
    ],
  },
  {
    id: 'area-inspections',
    name: 'Area Inspections',
    tagline: 'Water compliance and operational data collection.',
    description:
      'Standardize area inspections for water compliance and operational data collection, so the data you gather in the field is usable the moment it is captured.',
    features: [
      'Water compliance inspections',
      'Operational data collection',
      'Configurable inspection templates',
      'Trending across areas and sites',
    ],
  },
    {
    id: 'equipment-inspections',
    name: 'Equipment Inspections',
    tagline: 'Inspect equipment across drivers and keep each driver and management up-to-date.',
    description:
      'Tracks inspections of equipment across operators, keeping each operator and management up-to-date. Notifies maintenance and integrates with the mine equipment list Pulls in and uses project data and financial data from the systems you already run.',
    features: [
      'Mobile pre-op equipment inspection forms',
      'Automatic maintenance manager notification',
      'Defect history by vehicle',
      'Operator accountability records',
    ],
  }
];

export const services = [
  {
    id: 'integration',
    name: 'Systems Integration',
    description:
      'Your data already exists — it is just scattered across systems that were never designed to talk to each other. We connect them so information flows end to end.',
    points: [
      'Connect disparate existing systems',
      'Project and financial data integration',
      'SQL, NoSQL, flat file, and proprietary formats',
      'Validation, security, and auditing',
    ],
  },
  {
    id: 'spreadsheet-replacement',
    name: 'Spreadsheet Replacement',
    description:
      'Spreadsheets and paper break down at scale, and version control becomes a genuinely costly problem. We replace them with an actual solution.',
    points: [
      'Replace spreadsheet and paper processes',
      'Eliminate version control risk',
      'Single source of truth',
      'Migration from existing workbooks',
    ],
  },
  {
    id: 'process',
    name: 'Process Measurement & Improvement',
    description:
      'We help you collect and use the right data to measure and improve end-to-end processes, from extraction to handling to processing and beyond.',
    points: [
      'End-to-end process measurement',
      'Metrics selection and calculation',
      'Lean and Six Sigma practitioners',
      'Financial impact analysis',
    ],
  },
  {
    id: 'managed',
    name: 'Consulting & Managed Services',
    description:
      'Engage us to build it, run it, or both. We work alongside your team to achieve meaningful results as quickly as possible.',
    points: [
      'Implementation and rollout',
      'Ongoing managed operation',
      'Team enablement and training',
      'Long-term support',
    ],
  },
];

// Drives the footer's Legal column and the sidebar on each legal page.
export const legalDocs = [
  { path: '/legal/subscription-agreement', title: 'SaaS Subscription Agreement' },
  { path: '/legal/data-processing-addendum', title: 'Data Processing Addendum' },
  { path: '/legal/acceptable-use', title: 'Acceptable Use Policy' },
  { path: '/legal/privacy', title: 'Privacy Policy' },
];

// TODO: Replace with real published pricing. `price` and `cadence` are
// placeholders; every other field reflects actual product scope.
export const pricingTiers = [
  {
    id: 'app',
    name: 'Single Application',
    price: '$159',
    cadence: 'per site / month',
    summary: 'One process getting off paper forms and onto a real system.',
    includes: [
      'Inspections and reporting',
      'Unlimited field users',
      'Standard integrations',
      'Email and phone support',
    ],
    cta: 'Order',
    featured: false,
  },
  {
    id: 'site',
    name: 'Single Site',
    price: '$439',
    cadence: 'per month',
    summary: 'One operation getting off spreadsheets and onto a real system.',
    includes: [
      'Up to 4 applications',
      'Unlimited field users',
      'Standard integrations',
      'Email and phone support',
    ],
    cta: 'Order',
    featured: false,
  },
  {
    id: 'multi-site',
    name: 'Multi-Site',
    price: '$389',
    cadence: 'per site / month',
    summary: 'Several operations that need to roll up to one view.',
    includes: [
      'Full application suite',
      'Unlimited field users',
      'Project and financial integrations',
      'Cross-site reporting',
      'Priority support',
    ],
    cta: 'Order',
    featured: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: null,
    cadence: 'custom',
    summary: 'Enterprise rollouts with bespoke integration requirements.',
    includes: [
      'Everything in Multi-Site',
      'Custom application development',
      'Dedicated integration engineering',
      'Managed services option',
      'Named account team',
    ],
    cta: 'Talk to Us',
    featured: false,
  },
];
